import React from 'react';
import { MainNavigationItem } from './MainNavigationItem';

import { SearchIcon } from './Icons/SearchFilledIcon';
import { ShipIcon } from './Icons/ShipFilledIcon';
import { DiscountIcon } from './Icons/DiscountFilledIcon';
import { WorldIcon } from './Icons/WorldFilledIcon';
import { AnchorIcon } from './Icons/AnchorFilledIcon';
import { FaqIcon } from './Icons/FaqFilledIcon';
import { CompassIcon } from './Icons/CompassFilledIcon';
import { PackageIcon } from './Icons/PackageFilledIcon';
import { FavoritesIcon } from './Icons/FavoritesIcon';
import styled from '@emotion/styled';

interface IProps {
    menuItems: any[];
    isTopNavigation?: boolean;
}

const homeNavItemStyle: any = {
    border: `1px solid #c3c3c3`,
    margin: '10px 15px',
};

const lastTopNavItemStyle: any = {
    borderBottom: '0',
};

const MenuWrapper = styled.ul`
    margin: 0px 0 15px;
    padding: 0;
`;

const IconWrapper = styled.span`
    color: ${({ theme }) => theme.icon.brandColor1};
    fill: ${({ theme }) => theme.icon.brandColor1};
    margin-right: 5%;
`;

const BlankIconStyled = styled.div`
    margin-right: 5%;
    width: 24px;
    height: 24px;
`;

const iconClasses = [
    { label: 'SearchIcon', icon: SearchIcon, isShownAtCollapsibleSection: false },
    { label: 'WorldIcon', icon: WorldIcon, isShownAtCollapsibleSection: true },
    { label: 'AnchorIcon', icon: AnchorIcon, isShownAtCollapsibleSection: true },
    { label: 'ShipIcon', icon: ShipIcon, isShownAtCollapsibleSection: true },
    { label: 'CompassIcon', icon: CompassIcon, isShownAtCollapsibleSection: false },
    { label: 'DiscountIcon', icon: DiscountIcon, isShownAtCollapsibleSection: true },
    { label: 'FaqIcon', icon: FaqIcon, isShownAtCollapsibleSection: false },
    { label: 'PackageIcon', icon: PackageIcon, isShownAtCollapsibleSection: false },
    { label: 'FavoriteIcon', icon: FavoritesIcon, isShownAtCollapsibleSection: false },
];

export function MainNavigationMenu({ menuItems, isTopNavigation = true }: IProps) {
    const getMainNavigation = () => {
        return (menuItems || []).map((item, index) => {
            const isLastItem = index === menuItems.length - 1;
            const topNavItemStyle: any = isLastItem ? lastTopNavItemStyle : {};
            const Icon = iconClasses.find((iconClass) => {
                return iconClass.label === item.icon;
            });
            const MenuIcon = Icon?.icon ? (
                <Icon.icon width={24} height={24} />
            ) : (
                <BlankIconStyled />
            );
            const showItem = isTopNavigation || Icon?.isShownAtCollapsibleSection;
            if (showItem) {
                return (
                    <MainNavigationItem
                        key={index}
                        item={item}
                        iconClass={item.icon}
                        itemStyle={isTopNavigation ? topNavItemStyle : homeNavItemStyle}
                        isTopNavigation={isTopNavigation}
                    >
                        <IconWrapper>{MenuIcon}</IconWrapper>
                    </MainNavigationItem>
                );
            }
            return null;
        });
    };

    return <MenuWrapper>{getMainNavigation()}</MenuWrapper>;
}
